import { Stack, StackProps } from '@mui/material';
import { useReactiveVar } from '@apollo/client';
import { hasUrgentToolbar } from '../../app/ui/urgent-notifications/urgent-notifications';


export const ListPageWrapper = ({sx = {}, ...rest}: StackProps) => {
  const hasToolbar = useReactiveVar(hasUrgentToolbar);

  return <Stack {...rest}
                sx={{
                  margin: '16px 24px 24px',
                  transition: 'all 0.3s ease-in-out',
                  maxHeight: `calc(100vh - ${hasToolbar ? 46 : 16}px)`,
                  ...sx
                }} />
}


